import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {GlobalStateContext} from "../layouts/GlobalStates";
import AuthModal from "./../component/global/AuthModal/index";
import FeedbackRoutes from "../routes/FeedbackRoutes";
import "../i18n/i18n";
import "./main.scss";

export default function FeedbackApp() {
  const {t, i18n} = useTranslation();
  const {feedbackAppGlobalState} = useContext(GlobalStateContext);
  const {auth} = useContext(GlobalStateContext);

  const isQRCodeUser = (id) => {
    const value = id * 1;
    const isNumber = typeof value === "number" && isFinite(value);
    console.log(id, value, isNumber);
    return !isNumber;
  };

  // const RouteRenderer = () => {
  //   return (
  //     <>
  //       <Route
  //         path="/menu/:id"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <FoodSection/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route
  //         path="/share-product/:id"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <ShareProduct/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route
  //         path="/more/:id"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <More/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route
  //         path="/similar/:id"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <Similar/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route path="/didban-share/:id" element={<DidbanShare/>}/>
  //       <Route
  //         path="/form/:id"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <Rating/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route
  //         path="/:id/share/:isIntro"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <Product/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route
  //         path="/:id/:nothing"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <Product/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //       <Route
  //         path="/:id/"
  //         element={
  //           feedbackAppGlobalState[0].data?.form ? (
  //             <Product/>
  //           ) : (
  //             <Landing/>
  //           )
  //         }
  //       />
  //     </>
  //   );
  // };

  return (
    <div className="main-feedback-app-con">
      {/* <Store.Provider value={globalState}> */}
      {/*{feedbackAppGlobalState[0].data?.form ? (*/}
      {/*  <Layout id={feedbackAppGlobalState[0].productId}>*/}
      {/*    <Routes>{RouteRenderer()}</Routes>*/}
      {/*  </Layout>*/}
      {/*) : (*/}
      {/*  <Routes>*/}
      {/*    {RouteRenderer()}*/}
      {/*    <Route path="/" element={<NotFound/>}/>*/}
      {/*    <Route path="/400" element={<NotFound/>}/>*/}
      {/*    <Route path="/500" element={<NoInternet/>}/>*/}
      {/*  </Routes>*/}
      {/*)}*/}
      <FeedbackRoutes/>
      {auth.access_token === "" &&
        feedbackAppGlobalState[0].ajax?.item &&
        !isQRCodeUser(feedbackAppGlobalState[0].productId) && (
          <AuthModal showModal={true}/>
        )}
      {/* </Store.Provider> */}
    </div>
  );
}
